"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Notification = _interopRequireDefault(require("../Notification"));

var _Label = _interopRequireDefault(require("./Label/Label"));

var _Background = _interopRequireDefault(require("./Background/Background"));

var _List = _interopRequireDefault(require("./List/List"));

var _UploadBar = _interopRequireDefault(require("./UploadBar.style"));

var UploadBar =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UploadBar, _PureComponent);

  function UploadBar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UploadBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UploadBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      expanded: _this.props.expanded
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "toggle", function () {
      _this.setState(function (_ref) {
        var expanded = _ref.expanded;
        return {
          expanded: !expanded
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(UploadBar, [{
    key: "render",
    value: function render() {
      var expanded = this.state.expanded;
      var _this$props = this.props,
          onItemIconClick = _this$props.onItemIconClick,
          uploads = _this$props.uploads,
          percent = _this$props.percent,
          timeLeft = _this$props.timeLeft,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["onItemIconClick", "uploads", "percent", "timeLeft"]);
      var labelProps = {
        uploads: uploads,
        percent: percent,
        timeLeft: timeLeft
      };
      return _react.default.createElement(_UploadBar.default, {
        expanded: expanded
      }, _react.default.createElement(_Notification.default, (0, _extends2.default)({
        className: (0, _classnames.default)('UploadBar', expanded && 'UploadBar__expanded'),
        onIconClick: this.toggle,
        icon: uploads.length <= 1 ? '' : 'angle-down',
        label: function label() {
          return _react.default.createElement(_Label.default, labelProps);
        },
        border: false
      }, other), _react.default.createElement(_Background.default, {
        percent: this.props.percent
      }), expanded && _react.default.createElement(_List.default, {
        uploads: uploads,
        onItemIconClick: onItemIconClick
      })));
    }
  }]);
  return UploadBar;
}(_react.PureComponent);

UploadBar.defaultProps = {
  expanded: false,
  timeLeft: ''
};
UploadBar.propTypes = {
  expanded: _propTypes.default.bool,
  onItemIconClick: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  uploads: _propTypes.default.array.isRequired,
  percent: _propTypes.default.number.isRequired,
  timeLeft: _propTypes.default.string
};
var _default = UploadBar;
exports.default = _default;